import { IPublicClientApplication } from "@azure/msal-browser";
import { BaseService } from "./base.service";

export class UserService extends BaseService {
  constructor(instance: IPublicClientApplication) {
    super(instance);
  }

  public async createUser(): Promise<any> {
    // Original
    // var options = this.getHeaderOption("POST");
    // const response = await fetch(`${this.getEndPoint()}/api/user`, options);

    // Mew Refetch Token
    const url = `${this.getEndPoint()}/api/user`;
    const method = "POST";

    const response = await this.getHeaderOptionWithToken(url, method);

    if (response.ok) {
      const responseAsJson = await response.json(); //(await response.json())?.value?.token;
      const token = responseAsJson.acsUserIdentity;
      if (token) {
        return responseAsJson;
      }
    }
    throw "Invalid user response";
  }

  public async deleteUser(): Promise<any> {
    // var options = this.getHeaderOption("DELETE");
    // const response = await fetch(`${this.getEndPoint()}/api/user`, options);

    // Mew Refetch Token
    const url = `${this.getEndPoint()}/api/user`;
    const method = "DELETE";

    const response = await this.getHeaderOptionWithToken(url, method);

    if (response.ok) {
      return response;
    }
    throw "Invalid user response";
  }
}
